import { SearchCriteria } from "./search-criteria";

export class GetGiftCardOTPCodesSearchCriteria extends SearchCriteria {
  public GiftCardInformationId: number;
}
